import { IAppState } from '../../../AppModulesWrapper';

export function selectPublishTerms(state: IAppState) {
  return state.servicePickerWidget.publishTerms;
}
